const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

const KEY = "mirai-cookie-consent";
export const getConsent = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};
export const setConsent = (v) => localStorage.setItem(KEY, JSON.stringify({ ...v, at: new Date().toISOString() }));

const addScript = (src) => {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
};

export const initAnalytics = () => {
  const c = getConsent();
  if (!c) return;
  if (GA_ID && c.analytics && !window.gtag) {
    addScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID);
  }
  if (PIXEL_ID && c.marketing && !window.fbq) {
    const fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
    fbq.queue = []; fbq.loaded = true; fbq.version = "2.0"; fbq.push = fbq;
    window.fbq = fbq; window._fbq = fbq;
    addScript("https://connect.facebook.net/en_US/fbevents.js");
    fbq("init", PIXEL_ID);
    fbq("track", "PageView");
  }
};

export const trackWhatsApp = (location) => {
  window.gtag?.("event", "whatsapp_click", { location });
  window.fbq?.("track", "Contact", { method: "whatsapp", location });
};

export const trackCall = (location) => {
  window.gtag?.("event", "phone_click", { location });
  window.fbq?.("track", "Contact", { method: "phone", location });
};

export const trackLead = (programme) => {
  window.gtag?.("event", "generate_lead", { programme });
  window.fbq?.("track", "Lead", { content_name: programme });
};
